// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container {
    max-width: 700px;
    margin: 0 auto;
    padding: 2rem 1.5rem;
    line-height: 1.6;
}

.contact-title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    text-align: center;
}

.contact-section {
    margin-bottom: 2rem;
}

.contact-email {
    font-size: 1.2rem;
    margin: 1rem 0;
}

    .contact-email a {
        color: #0066cc;
        text-decoration: none;
        font-weight: 500;
    }

        .contact-email a:hover {
            text-decoration: underline;
        }

.contact-note {
    font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/ContactUs.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;IAEI;QACI,cAAc;QACd,qBAAqB;QACrB,gBAAgB;IACpB;;QAEI;YACI,0BAA0B;QAC9B;;AAER;IACI,iBAAiB;AACrB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.contact-container {\r\n    max-width: 700px;\r\n    margin: 0 auto;\r\n    padding: 2rem 1.5rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.contact-title {\r\n    font-size: 2rem;\r\n    margin-bottom: 1.5rem;\r\n    text-align: center;\r\n}\r\n\r\n.contact-section {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.contact-email {\r\n    font-size: 1.2rem;\r\n    margin: 1rem 0;\r\n}\r\n\r\n    .contact-email a {\r\n        color: #0066cc;\r\n        text-decoration: none;\r\n        font-weight: 500;\r\n    }\r\n\r\n        .contact-email a:hover {\r\n            text-decoration: underline;\r\n        }\r\n\r\n.contact-note {\r\n    font-size: 0.9rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
